import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import _ from 'lodash';

import Message from '../form/Message';
import OrganizationApi from '../../api/organization';
import UserApi from '../../api/user';
import { history } from '../../state/store';
import AuthUtils from '../../AuthUtils';

class MembersList extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            members: [],
            roles: [],
            message: '',
            practices: [],
            hideRoles: props.hideRoles,
            hidePractices: props.hidePractices,
            orgId: null,
        };

        this.getMembers = this.getMembers.bind(this);
        this.removeMember = this.removeMember.bind(this);
        this.getRoles = this.getRoles.bind(this);
        this.changeRole = this.changeRole.bind(this);
        this.reinviteMember = this.reinviteMember.bind(this);
        this.getPractices = this.getPractices.bind(this);
    }

    componentDidMount() {
        this.getRoles();
        this.getMembers();
        this.getPractices();
    }

    componentDidUpdate(prevProps) {
        if (this.state.members !== prevProps.members) {
            this.setState({
                members: prevProps.members,
            });
        }
    }

    getMembers() {
        if (this.props.organizationId > 0) {
            let { members } = this.props;
            let newMembers = members.map(obj => {
                obj.resourceFull = AuthUtils.deserializeResource(obj.resource);
                if (_.has(obj, `resourceFull.organizations.${this.props.organizationId}`)) {
                    obj.role = _.get(obj, `resourceFull.organizations.${this.props.organizationId}`);
                } else {
                    for (let i = 1; i <= this.state.practices.length; i++) {
                        if (_.has(obj, `resourceFull.practices.${i}`)) {
                            obj.role = _.get(obj, `resourceFull.practices.${this.props.organizationId}`);
                            break;
                        }
                    }
                }
                return obj;
            }, this);
            this.setState({
                members: newMembers,
            });
        } else {
            this.setState({
                members: this.props.members,
            });
        }
    }

    getRoles() {
        UserApi.listRoles()
            .then(roles => {
                roles = roles.map(role => {
                    return { value: role, label: role };
                });
                this.setState({ roles: roles });
            })
            .catch(err => {
                console.error('Team member list error', err);
            });
    }

    changeRole(member, newRole) {
        this.setState({
            message: member.name + ' changed to ' + newRole.label,
        });
        let newMemberJson = member;
        newMemberJson['role'] = newRole.value;
        newMemberJson['org'] = this.props.organizationId;

        // TODO-- modify the resource, not the role
        UserApi.updateAttrs(newMemberJson);
    }

    async changePractice(member, newPractice) {
        console.log(member, newPractice);
        // prevent consultants from getting their permissions mucked with:
        if (member.resource === '*') {
            this.setState({
                message: member.name + ' has privileges outside of the organization, cannot update ',
            });
            return false;
        }

        let newMemberJson = member;
        //handle org-level update:
        if (newPractice.value === '*') {
            newMemberJson['resource'] = `organization:${this.props.organizationId}`;
        } else {
            newMemberJson['resource'] = `practice:${newPractice.value}`;
        }

        // newMemberJson['role'] = newRole.value;
        newMemberJson['org'] = this.props.organizationId;
        newMemberJson['practice'] = newPractice.value;

        this.setState({
            message: member.name + ' changed to ' + newPractice.label,
        });
        let newresource = await UserApi.updateAttrs(newMemberJson);
        console.log(newresource);
    }

    reinviteMember(member, e) {
        e.preventDefault();
        this.setState({ message: `Resending email to ${member.email}` });
    }

    removeMember(member, e) {
        e.preventDefault();
        let r = window.confirm(`This action will remove ${member.email} and PERMANENTLY remove their access.\n\nAre you sure you want to proceed?`);
        if (!r) {
            return;
        }
        // TODO -- send information to backend to remove org and practice access...

        console.log(member);
        UserApi.delete(member.email, this.props.organizationId)
            .then(data => {
                this.setState({
                    message: `Remove user called for id:${member.email}`,
                });
                let newMembersState = this.state.members.filter(mem => mem.email !== member.email);
                this.setState({ members: newMembersState });
            })
            .catch(err => {
                this.setState({ message: `Error: ${err}` });
                console.error(err);
            });
    }

    deleteConsultant(member, e) {
        e.preventDefault();
        let r = window.confirm(`This action will PERMANENTLY delete ${member.email} from both Annual and Initial.\n\nAre you sure you want to proceed?`);
        if (!r) {
            return;
        }
        // TODO -- send information to backend to remove org and practice access...

        UserApi.deleteConsultant(member.email)
            .then(data => {
                this.setState({
                    message: `Remove user called for id:${member.email}`,
                });
                let newMembersState = this.state.members.filter(mem => mem.email !== member.email);
                this.setState({ members: newMembersState });
            })
            .catch(err => {
                this.setState({ message: `Error: ${err}` });
                console.error(err);
            });
    }

    editMember = (member, e) => {
        console.log(member, 'member');
        e.preventDefault();
        history.push(`/consultant/team/edit/${member.email}`);
    };

    addMember() {
        if (this.state.hidePractices) {
            // we're in the consultant page
            history.push(`/consultant/team/new`);
        } else {
            //not hiding practices means we're in the org management page
            history.push(`/organization/${this.state.orgId}/team/new`);
        }
    }

    renderReinvite(member) {
        if (member.invitation_status === 'Pending') {
            return (
                <span>
                    &nbsp;(
                    <Link to="" onClick={e => this.reinviteMember(member, e)}>
                        Resend Invitation
                    </Link>
                    )
                </span>
            );
        }
    }

    getPractices() {
        if (!this.state.hidePractices) {
            OrganizationApi.getPractices(this.props.organizationId)
                .then(practices => {
                    practices = practices.map(practice => {
                        return { value: practice.id, label: practice.name };
                    });
                    practices.unshift({ value: '*', label: 'All' });
                    this.setState({ practices: practices });
                    this.getMembers();
                }, this)
                .catch(errorMessage => {
                    console.log('Error: ' + errorMessage);
                });
        }
    }

    getPracticeValue(str) {
        let resource = AuthUtils.deserializeResource(str);
        if (resource.organizations && resource.organizations[this.props.organizationId]) {
            return '*';
        } else if (resource.practices) {
            return Object.keys(resource.practices)[0]; // TODO -- multiple practices?
        }
        let split = str.split(':');
        if (split.length > 1) {
            if (split[0] === 'organization') {
                return '*';
            } else return split[1];
        } else return str;
    }

    render() {

        return (
            <div className="table-wrapper">
                <Message info={this.state.message} />
                <table className="table--organization-members">
                    <thead>
                        <tr>
                            <th className="stretch">Name</th>
                            <th>Invitation Status</th>
                            {!this.state.hideRoles ? <th>Role</th> : null}
                            {!this.state.hidePractices ? <th>Practice</th> : null}
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.members.map(mem => (
                            <tr key={mem.email}>
                                <td>
                                    {mem.name ? mem.name : mem.email} <br />
                                    <a href={`mailto:${mem.email}`}>{mem.email}</a>
                                </td>
                                <td>
                                    {mem.status}
                                    {this.renderReinvite(mem)}
                                </td>
                                {!this.state.hideRoles ? (
                                    <td>
                                        <Select name="roles" options={this.state.roles} value={mem.role} onChange={e => this.changeRole(mem, e)} clearable={false} searchable={false} />
                                    </td>
                                ) : null}

                                {!this.state.hidePractices ? (
                                    <td>
                                        <Select
                                            name="practices"
                                            options={this.state.practices}
                                            value={this.getPracticeValue(mem.resource) || this.state.practices[0]}
                                            onChange={e => this.changePractice(mem, e)}
                                            clearable={false}
                                            searchable={false}
                                        />
                                    </td>
                                ) : null}
                                {this.state.hidePractices ? (
                                    <td className="align-right">
                                        <Link
                                            to={``}
                                            title="Edit member"
                                            onClick={e => {
                                                this.editMember(mem, e);
                                            }}>
                                            <i className="fa fa-edit" />
                                        </Link>
                                    </td>
                                ) : null}
                                <td className="align-right">
                                    {_.isEmpty(this.props.organizationId) ? (
                                        <Link
                                            to={``}
                                            title="Remove member"
                                            onClick={e => {
                                                this.deleteConsultant(mem, e);
                                            }}>
                                            <i className="fa fa-trash" />
                                        </Link>
                                    ) : (
                                        <Link
                                            to={``}
                                            title="Remove member"
                                            onClick={e => {
                                                this.removeMember(mem, e);
                                            }}>
                                            <i className="fa fa-trash" />
                                        </Link>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default MembersList;
